import { ResultsMode } from 'interfaces/experimentResults';

// One vocabulary for the scope of every export flow.
export const getCasesFieldLabel = (isSlidesMode: boolean) => (isSlidesMode ? 'Slides' : 'Cases');

export const getScopeOptionLabels = (isSlidesMode: boolean) => ({
  selected: `Selected ${isSlidesMode ? 'slides' : 'cases'}`,
  filtered: `${getCasesFieldLabel(isSlidesMode)} matching current filters`,
  whole: 'Whole study',
});

export const describeResultSource = (resultsMode?: ResultsMode, orchestrationId?: string) =>
  resultsMode === ResultsMode.InternallyApproved
    ? 'Internally approved results'
    : resultsMode === ResultsMode.Manual
    ? orchestrationId
      ? `Orchestration ${orchestrationId}`
      : 'Latest result per slide'
    : 'Published results';

export const excludedCasesOptions = [
  { value: 'without', label: 'Without excluded cases' },
  { value: 'with', label: 'Include excluded cases' },
];
